import {
  size_default
} from "./chunk.SI24X5IH.js";
import {
  variants_default
} from "./chunk.7OG3CMFN.js";
import {
  appearance_default
} from "./chunk.GO6CI477.js";
import {
  WebAwesomeElement,
  n,
  t
} from "./chunk.LVUMIIKQ.js";
import {
  ke
} from "./chunk.S3625EU6.js";
import {
  __decorateClass
} from "./chunk.SZE6ONST.js";

// src/styles/native/callout.css
var callout_default = ":host,\n.wa-callout {\n  --spacing: var(--wa-space-m);\n\n  position: relative;\n  align-items: stretch;\n  border-radius: var(--wa-panel-border-radius);\n  background-color: var(--background-color, var(--wa-color-fill-quiet));\n  border-color: var(--border-color, transparent);\n  border-style: var(--wa-panel-border-style);\n  border-width: var(--wa-panel-border-width);\n  color: var(--text-color, var(--wa-color-on-normal));\n  padding: var(--spacing);\n}\n\n:host([appearance~='accent']),\n:host(.wa-accent),\n.wa-callout.wa-accent {\n  font-weight: var(--wa-font-weight-semibold);\n}\n";

// src/components/callout/callout.css
var callout_default2 = ":host {\n  --icon-color: currentColor;\n  --icon-size: var(--wa-font-size-l);\n\n  display: flex;\n}\n\n[part~='icon'] {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  color: var(--icon-color);\n  font-size: var(--icon-size);\n\n  ::slotted(*) {\n    margin-inline-end: var(--spacing);\n  }\n}\n\n[part~='message'] {\n  flex: 1 1 auto;\n  display: block;\n  overflow: hidden;\n}\n";

// src/components/callout/callout.ts
var WaCallout = class extends WebAwesomeElement {
  constructor() {
    super(...arguments);
    this.variant = "inherit";
    this.appearance = "outlined filled";
    this.size = "inherit";
  }
  render() {
    return ke`
      <div part="icon">
        <slot name="icon"></slot>
      </div>

      <div part="message">
        <slot></slot>
      </div>
    `;
  }
};
WaCallout.shadowStyle = [variants_default, appearance_default, size_default, callout_default, callout_default2];
__decorateClass([
  n({ reflect: true, initial: "brand" })
], WaCallout.prototype, "variant", 2);
__decorateClass([
  n({ reflect: true })
], WaCallout.prototype, "appearance", 2);
__decorateClass([
  n({ reflect: true, initial: "medium" })
], WaCallout.prototype, "size", 2);
WaCallout = __decorateClass([
  t("wa-callout")
], WaCallout);

export {
  WaCallout
};
